import * as Yup from "yup";
import {
  IFieldInstance,
  IncidentType,
} from "../../../../../types/fieldInstance.interface";
import {
  getStaticShape,
  getYupValidator,
} from "../../../../../utils/formGenUtils/getYupValidator";
import { getFormFieldsByProperty } from "../../../../../utils/formGenUtils/hashTable";

export const GuestValidator = () => {
  return Yup.object({
    facilityId: Yup.string().required("Facility is required"),
  });
};

export const RegularUserValidator = () => {
  return Yup.object({
    facilityId: Yup.string().required("Facility is required"),
    residentId: Yup.string().required("Resident is required"),
  });
};

export const getIncidentFormValidator = (
  fields: IFieldInstance[],
  viewModel: any,
  rlViewModel: any,
  isSubmittedIncident: boolean = false
) => {
  return Yup.object(
    getYupValidator(fields, viewModel, rlViewModel, undefined, isSubmittedIncident)
  );
};

export const getStaticShapeFormValidator = (
  fields: IFieldInstance[],
  incidentType: string
) => {
  const isFieldRequired = (field: IFieldInstance) => {
    if (field.required && field.childFieldIds.length) {
      const toggleBoxChildren = [
        ...getFormFieldsByProperty(
          "fieldType",
          "Togglebox",
          undefined,
          undefined,
          field.childFieldIds
        ),
      ];
      if (toggleBoxChildren) {
        return false;
      }
    }
    if (!field.incidentType.includes(incidentType as IncidentType)) {
      return false;
    }
    return field.required && !field.parentFieldId;
  };
  const requiredFields = fields.filter((field) => isFieldRequired(field));
  return Yup.object(getStaticShape(fields, requiredFields));
};
